import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Spinner,
} from "reactstrap";

const ApproveConfirmationModal = ({ isOpen, toggle, banner, onConfirm, loading }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle} className="bg-success text-white">
        <i className="mdi mdi-check-circle me-2"></i>Approve Banner Image
      </ModalHeader>
      <ModalBody>
        {banner && (
          <div>
            <p className="mb-3">
              Are you sure you want to approve this banner image?
            </p>
            <div className="bg-light p-3 rounded">
              <div className="mb-2">
                <strong>Banner ID:</strong> <span className="font-monospace">{banner.id}</span>
              </div>
              {banner.userId && (
                <div className="mb-2">
                  <strong>User ID:</strong> <span className="font-monospace">{banner.userId}</span>
                </div>
              )}
              {banner.banner_image_url && (
                <div className="mt-3">
                  <img
                    src={banner.banner_image_url}
                    alt="Banner preview"
                    className="img-fluid rounded"
                    style={{ maxHeight: "200px", width: "auto" }}
                    onError={(e) => { e.target.style.display = "none"; }}
                  />
                </div>
              )}
            </div>
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle} disabled={loading}>
          Cancel
        </Button>
        <Button color="success" onClick={onConfirm} disabled={loading}>
          {loading ? (
            <>
              <Spinner size="sm" className="me-2" />
              Approving...
            </>
          ) : (
            <>
              <i className="mdi mdi-check me-2"></i>Approve
            </>
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ApproveConfirmationModal;

